import { createSelector } from '@ngrx/store';
import { Installer } from '../../domains/users';
import { Connection } from '../../domains/users/connection/connection.model';
import { KudosReason } from '../../domains/users/kudos-reason/kudos-reason.model';
import { PhoneNumberEntry } from '../../shared/components/advanced-phone-number-manager/models/phone-number-entry.model';
import { currentInstallerComplianceRecords } from './compliance.selectors';
import { currentInstallerHammerRatingDetails } from './hammer-rating-details.selectors';
import { currentInstallerConnection } from './installer-connection.selectors';
import { currentInstallerKudosReason, currentInstallerKudosReasonDetails } from './kudos-reasons-details.selectors';
import { ComplianceRecord } from './models/compliance-record.model';
import { DetailedInstallerProfileContext, KudosReasonsDetails, } from './models/detailed-installer-profile-context.model';
import { ExtendedHammerRatingDetails } from './models/extended-hammer-rating.details.model';
import { InstallationTypeSubtypesClaimed } from './models/installation-type-subtypes-claimed.model';
import { currentInstallerPhoneNumberEntries } from './phone-number-details.selectors';
import { currentInstallerProductInstallationSubtypes } from './product-installation-type-and-subtype.selectors';
import { currentInstallerReputationScore, ReputationScoreWithTier } from './reputation-score.selectors';
import { isCurrentInstallerAlsoCurrentUser } from './store/feature.selectors';
import { currentInstaller } from './store/profile.selectors';


export const detailedInstallerProfileContext = createSelector(
  currentInstaller,
  currentInstallerConnection,
  currentInstallerKudosReasonDetails,
  currentInstallerKudosReason,
  currentInstallerHammerRatingDetails,
  currentInstallerProductInstallationSubtypes,
  currentInstallerComplianceRecords,
  currentInstallerPhoneNumberEntries,
  currentInstallerReputationScore,
  isCurrentInstallerAlsoCurrentUser,
  (
    installer: Installer | undefined,
    connection: Connection | undefined,
    kudosReasonsDetails: KudosReasonsDetails | undefined,
    kudosReason: KudosReason | undefined,
    hammerRatingDetails: ExtendedHammerRatingDetails[] | undefined,
    productInstallationSubtypesClaimed: InstallationTypeSubtypesClaimed[] | undefined,
    complianceRecords: ComplianceRecord[],
    phoneNumberEntries: PhoneNumberEntry[] | undefined,
    reputationScore: ReputationScoreWithTier | undefined,
    canEditProfile: boolean,
  ): DetailedInstallerProfileContext | undefined =>
    installer
      ? {
        installer,
        connection,
        kudosReasonsDetails,
        kudosReason,
        hammerRatingDetails: hammerRatingDetails || [],
        productInstallationSubtypesClaimed: productInstallationSubtypesClaimed || [],
        complianceRecords,
        phoneNumberEntries,
        reputationScore,
        canEditProfile,
      }
      : undefined,
);
